import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[640px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Naruto%20ninja%20village%20Konoha%20silhouette%20at%20sunset%20with%20warm%20orange%20and%20amber%20sky%2C%20traditional%20Japanese%20architecture%2C%20Hokage%20mountain%20in%20background%2C%20artistic%20painterly%20style%20not%20photorealistic%2C%20soft%20gradient%20colors%2C%20atmospheric%20and%20dreamy&width=1920&height=1080&seq=hero-bg-2026&orientation=landscape"
          alt="火影同人本子 - 木叶忍者村黄昏全景"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/55"></div>

      <div className="relative z-10 w-full text-center px-4 md:px-6">
        <div className="max-w-3xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-background-50/15 backdrop-blur-sm border border-background-50/20 mb-6">
            <i className="ri-sparkling-2-line text-primary-400 text-sm"></i>
            <span className="text-sm text-background-50/90">火影忍者粉丝二次创作平台</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-background-50 mb-4 leading-tight">
            火影同人本子
            <span className="block text-primary-400 text-xl md:text-3xl mt-2 font-body font-light tracking-wide">
              精选创作合集
            </span>
          </h1>

          <p className="text-background-50/80 text-sm md:text-base max-w-lg mx-auto mb-8 leading-relaxed">
            汇聚优质火影同人漫画、小说、画集等创作资源，连接同人作者与读者，让每一份热爱都被看见
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/category/manhua"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-full font-medium text-sm transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-book-read-line"></i>
              探索同人作品
            </Link>
            <Link
              to="/about"
              className="inline-flex items-center gap-2 px-6 py-3 bg-background-50/10 hover:bg-background-50/20 text-background-50 rounded-full font-medium text-sm backdrop-blur-sm border border-background-50/30 transition-all duration-200 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-information-line"></i>
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <i className="ri-arrow-down-line text-background-50/60 text-2xl"></i>
      </div>
    </section>
  );
}